import { render, staticRenderFns } from "./CoPeople.vue?vue&type=template&id=055dc46c&scoped=true&"
import script from "./CoPeople.vue?vue&type=script&lang=ts&"
export * from "./CoPeople.vue?vue&type=script&lang=ts&"
import style0 from "./CoPeople.vue?vue&type=style&index=0&id=055dc46c&prod&lang=less&scoped=true&"
import style1 from "./CoPeople.vue?vue&type=style&index=1&id=055dc46c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055dc46c",
  null
  
)

export default component.exports